import React from 'react';
import {LargeText, Striped, ThemedHeader, TwoColumnRow} from '../Styled';

export default function Sites() {
    return (
        <React.Fragment>
            <Striped>
                <TwoColumnRow>
                    <span>
                        <ThemedHeader>South Side<br/>Point Of The Mountain, UT</ThemedHeader>
                        <LargeText>Point of the mountain is one of our all time favorite places to fly in the United States. Boasting over 300 flyable days away and located just minutes from downtown Salt Lake City, Utah makes Point of the Mountain one of the most consistent and easily accessible flying sites in thecountry.</LargeText>
                    </span>
                    <iframe title='South Side' style={{border: 0, width: '100%', height: '350px'}} frameBorder={0}
                            allowFullScreen={true}
                            src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3035.7809498189918!2d-111.9033126846028!3d40.45798497936022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDI3JzI4LjgiTiAxMTHCsDU0JzA0LjAiVw!5e0!3m2!1sen!2sus!4v1448557174473'/>
                </TwoColumnRow>
            </Striped>

            <Striped>
                <TwoColumnRow>
                    <iframe title='North Side' className='mobile-row-2'
                            style={{border: 0, width: '100%', height: '350px'}} frameBorder={0} allowFullScreen={true}
                            src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3035.089860811124!2d-111.89474868460236!3d40.47327697935861!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDI4JzIzLjgiTiAxMTHCsDUzJzMzLjIiVw!5e0!3m2!1sen!2sus!4v1448557870880'/>
                    <ThemedHeader className='mobile-row-1'>North Side<br/>Point Of The Mountain, UT</ThemedHeader>
                </TwoColumnRow>
            </Striped>

            <Striped>
                <TwoColumnRow>
                    <ThemedHeader>Inspiration Point (Inspo)<br/>Orem UT</ThemedHeader>
                    <iframe title='Inspiration Point' style={{border: 0, width: '100%', height: '300px'}}
                            frameBorder={0} allowFullScreen={true}
                            src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3042.871723800608!2d-111.62800268465111!3d40.30080707060546!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDE4JzAyLjkiTiAxMTHCsDM3JzMyLjkiVw!5e0!3m2!1sen!2sus!4v1448558733896'/>
                </TwoColumnRow>
            </Striped>
            <Striped>
                <TwoColumnRow>
                    <iframe title='Cottonwood Heights' className='mobile-row-2'
                            style={{border: 0, width: '100%', height: '300px'}} frameBorder={0} allowFullScreen={true}
                            src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3028.8756085454265!2d-111.78687568464305!3d40.61056805175176!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDM2JzM4LjAiTiAxMTHCsDQ3JzA0LjkiVw!5e0!3m2!1sen!2sus!4v1448559243242'/>
                    <ThemedHeader className='mobile-row-1'>The B<br/>Cottonwood Heights, UT</ThemedHeader>
                </TwoColumnRow>
            </Striped>
            <Striped>
                <TwoColumnRow>
                    <ThemedHeader>The V<br/>Bountiful, UT</ThemedHeader>
                    <iframe title='The V' style={{border: 0, width: '100%', height: '300px'}} frameBorder={0}
                            allowFullScreen={true}
                            src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3015.222957944202!2d-111.84687168463506!3d40.91085703336303!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDU0JzM5LjEiTiAxMTHCsDUwJzQwLjkiVw!5e0!3m2!1sen!2sus!4v1448559378936'/>
                </TwoColumnRow>
            </Striped>
        </React.Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/app/components/Sites.js